const getSortButtonLabel = (columnLabel, sortDirection = '') => {
    if (sortDirection) {
        return `sort by ${columnLabel} in ${sortDirection} order`;
    }
    return `disable sort by ${columnLabel}`;
};
export const columnHeader = {
    aria: {
        sortButtonLabel: getSortButtonLabel,
    },
};
//# sourceMappingURL=column-header.js.map